import baseURL from "../Api/baseURL";

const useGetData = async (url, params) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      admin:true
    },
  };
  const res = await baseURL.get(url, config);
  return res.data;
};

const useGetDataToken = async (url, params) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      admin:true
    },
    
  };
  const res = await baseURL.get(url, config);
  return res.data;
};

export { useGetData, useGetDataToken };
